import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import { pickInitialLanguage } from "./pick-language";

const LANGUAGE_KEY = "bizcoach_language";

/**
 * Langue de démarrage : `?lang=` d'abord (lien envoyé à un prospect), sinon le
 * choix mémorisé, sinon le français. La langue reçue par l'URL est mémorisée,
 * sinon elle serait perdue dès la navigation suivante — un prospect anglophone
 * repasserait en français après la création de son compte.
 */
function getSavedLanguage(): string {
  const search = typeof window !== "undefined" ? window.location.search : "";
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(LANGUAGE_KEY);
  } catch {
    // localStorage indisponible (navigation privée) → on se rabat sur l'URL.
  }
  const lang = pickInitialLanguage(search, stored);
  if (lang !== stored) {
    try {
      localStorage.setItem(LANGUAGE_KEY, lang);
    } catch {
      // idem : sans stockage, la langue vaut pour cette page uniquement.
    }
  }
  return lang;
}

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: getSavedLanguage(),
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

// `<html lang>` est écrit en dur à "fr" dans index.html : sans cette synchronisation, lecteurs
// d'écran et moteurs de traduction annoncent du français sur une page anglaise.
function syncDocumentLang(lang: string) {
  try {
    document.documentElement.lang = lang.toLowerCase().startsWith("en") ? "en" : "fr";
  } catch {
    // pas de DOM (rendu serveur, tests)
  }
}

syncDocumentLang(i18n.language || "fr");

export function changeLanguage(lang: string) {
  i18n.changeLanguage(lang);
  syncDocumentLang(lang);
  try {
    localStorage.setItem(LANGUAGE_KEY, lang);
  } catch {
    // localStorage not available
  }
}

export function getCurrentLanguage(): string {
  return i18n.language || "fr";
}

export default i18n;
